<template>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <!-- Product-zoom-area -->
      <div class="zoom-area">
        <div class="embed-responsive embed-responsive-16by9" v-if="showVideo">
        <iframe width="560" height="315" :src="selectedProductLocal.video_url + '?rel=0'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="main_product_image" v-else>
           <img
            class="img-fluid"
            height="100"
            v-lazy="{
                src:
                API_URL + '/storage/uploads/' + selectedProductLocal.singleImage?.name,
                loading: publicPath + 'assets/images/spinner.gif',
                error: publicPath + 'assets/images/not_found.png',
              }"
        />
        </div>
        <div class="d-flex">
          <div id="gallery" class="u-s-m-t-10" v-if="selectedProductLocal.images?.length > 1">
            <img
              class="gallery-thumb"
              v-for="(image, index) in selectedProductLocal.images"
              :class="{'active' : image.id == selectedProductLocal.singleImage.id && !showVideo}"
              :key="index"
              height="100"
              @click="changeThumbnail(image)"
              v-lazy="{
							src: API_URL + '/storage/uploads/' + image.name,
							loading: publicPath + 'assets/images/spinner.gif',
							error: publicPath + 'assets/images/not_found.png',}"
            />
        </div>
        <div id="video" class="u-s-m-t-10 mr-2" v-if="selectedProductLocal.video_url">
           <img
                class="video_icon"
                height="100"
                v-lazy="{
                src: publicPath + 'assets/images/video_player.png',
                loading: publicPath + 'assets/images/spinner.gif',
                error: publicPath + 'assets/images/not_found.png',}"
              />
              <img
                class="video_thumbnail"
                :class="{'active' : showVideo}"
                height="100"
                @click="changeThumbnail('video')"
                v-lazy="{
                src: getYoutubeThumbnail(selectedProductLocal.video_url),
                loading: publicPath + 'assets/images/spinner.gif',
                error: publicPath + 'assets/images/not_found.png',}"
              />
          </div>
        </div>
      </div>
      <!-- Product-zoom-area /- -->
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
      <!-- Product-details -->
      <!-- {{selectedProduct}} -->
      <div class="all-information-wrapper">
        <div class="section-1-title-breadcrumb-rating">
          <div class="product-title">
            <h1>
              <a href="">{{ selectedProductLocal.product_name }}</a>
            </h1>
          </div>
          <ul class="bread-crumb">
            <!-- <li class="has-separator">
              <a href="">Home</a>
            </li>
            <li class="has-separator">
              <a href="">Men's Clothing</a>
            </li>
            <li class="has-separator">

            </li> -->
            <li class="is-marked">
              <router-link
                :to="{
                  name: 'ProductsByCategory',
                  params: { id: selectedProduct.category.id, slug : 'category-name' },
                }"
                >{{ selectedProduct.category.name }}</router-link
              >
            </li>
          </ul>
          <div class="product-rating d-flex">
           	<StarRating
									:increment="1"
									:rating="selectedProduct.review"
									:star-size="15"
									:read-only="true"
									:show-rating="false"
				  	/>
            <span class="ml-1">({{selectedProduct.review != null ? selectedProduct.review : 0}})</span>
          </div>
        </div>
        <!-- <div class="section-2-short-description u-s-p-y-14">
          <h6 class="information-heading u-s-m-b-8">Description:</h6>
          <div v-html="selectedProductLocal.product_desc"></div>
        </div> -->
        <div class="section-3-price-original-discount u-s-p-y-14">
          <h6 class="information-heading u-s-m-b-8">Price:</h6>
          <div class="price" v-if="selectedProductLocal.stock">
            <h4>{{formatCurrency(selectedProductLocal.lowest_price )}}   <span v-if="selectedProductLocal.promotional"><i class="fa fa-star"></i></span></h4> <span v-if="selectedProductLocal.installation_price > 0">Installation Price: {{formatCurrency(selectedProductLocal.installation_price)}} </span>
            <span v-if="selectedProductLocal.installation_price == 0">Free Installation</span>
            <h5 v-if="quantity > 1" class="text-muted font-weight-bold">* {{quantity}} = {{formatCurrency(selectedProductLocal.lowest_price * quantity)}}</h5>
          </div>
            <div class="price" v-else>
              <h4>N/A</h4>
            </div>
          <div class="original-price" v-if="selectedProductLocal.stock">
            <span>M.R.P: </span>
            <span><b>{{formatCurrency(selectedProductLocal.mrp)}}</b></span>
          </div>
       
          <!-- <div class="discount-price">
            <span>Discount:</span>
            <span>8%</span>
          </div>
          <div class="total-save">
            <span>Save:</span>
            <span>$5</span>
          </div> -->
        </div>
        <div class="section-4-sku-information u-s-p-y-14">
          <h6 class="information-heading u-s-m-b-8">Sku Information:</h6>
          <div class="availability">
            <span>Sku:</span>
            <span>{{ selectedProductLocal.lowest_price_sku }}</span>
          </div>

          <div class="availability" v-if="selectedProductLocal.stock && selectedProductLocal.lowest_price_stock != 0">
            <span>Availability:</span>
            <span>In Stock</span>
          </div>
          <div class="left" v-if="selectedProductLocal.stock && selectedProductLocal.lowest_price_stock != 0">
            <span>Only:</span>
            <span>{{ selectedProductLocal.stock }} left</span>
          </div>

          <div class="availability" v-if="!selectedProductLocal.stock || selectedProductLocal.lowest_price_stock == 0">
            <span>Availability:</span>
            <span style="color: red">Not in Stock</span>
          </div>
        </div>
        <div class="section-5-product-variants u-s-p-y-14">
          <h6 class="information-heading u-s-m-b-8">Product Variants:</h6>
          <div
            class="color u-s-m-b-11"
            v-for="product_variant in product_variants"
            :key="product_variant.id"
          >
            <span>{{ product_variant.attribute }}</span>

            <div class="color-variant select-box-wrapper">
              <select
                class="select-box product-color"
                @change="onChange($event)"
                v-model="combination[product_variant.attribute_id]"
              >
                <option value="">Select</option>
                <option
                  :value="variation.id"
                  v-for="variation in product_variant.variations"
                  :key="variation.id"
                  :data-name="product_variant.attribute"
                  :data-combination-id="variation.combination_id"
                >
                  {{ variation.variation }}
                </option>
              </select>
            </div>
          </div>
        </div>
         <div class="section-5-product-variants pb-4">
          <h6 class="information-heading u-s-m-b-8">Quantity:</h6>
            <div class="color-variant select-box-wrapper">
             <div class="quantity">
                <input type="text" class="quantity-text-field" v-model="quantity" @change="handleQuantityChange"  />
                <a class="plus-a" data-max="1000" @click="handleQuantity('inc')">&#43;</a>
                <a class="minus-a" data-min="1" @click="handleQuantity('dec')">&#45;</a>
              </div>
          </div>
        </div>
          <!-- Warehouse Selection -->
        
         <div class="facet-filter-by-shipping">
              <h3 class="title-name">Select Warehouse</h3>
              <div class="form-check" v-for="(warehouse, index) in warehouses" :key="index">
                <input :checked="warehouse.id == currWarehouse_id" class="radio-box" type="radio" name="warehouse" :id="index" @change="() => onChangeWarehouse({id : parseInt(warehouse.id)})">
                <label class="label-text" :for="index">
                 {{warehouse.name}}&nbsp;&nbsp;
                </label>
                <router-link v-if="warehouse.business_details" class="fa fa-link" :to="{name : 'Seller', params : {slug : warehouse.business_details.slug}}"></router-link>
              </div>
          </div>
           <!-- Warehouse Selection End -->
             <!-- Warehouse Selection -->
         <div v-if="LIGHTENING_DEAL != 'false'" class="facet-filter-by-shipping" >
              <h3 class="title-name" style="border-bottom: 0px; padding-bottom:0px;">Lightening Deal</h3>
              <div class="progress mb-1" style="height: 2px;">
                <div class="progress-bar bg-dark" role="progressbar"  :style="{width : getRemainingTime + '%'}" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <input  class="radio-box" type="radio" name="deal" id="deal"  >
                <label class="label-text" for="deal" >
                 {{ formatCurrency(3000)}}
                </label>
              <div class="end_in">
                <span class="font-weight-bold" style="font-size:0.9rem">Ends in : </span>
                <span class="font-weight-bold" style="font-size:0.9rem">{{msToHMS(deal_timer)}}</span>
              </div>
          </div>
           <!-- Warehouse Selection End -->
        <div class="section-6-social-media-quantity-actions u-s-p-y-14">
          <form action="#" class="post-form">
            <div class="quick-social-media-wrapper u-s-m-b-22">
              <span>Share:</span>
              <ul class="social-media-list">
                <li>
                  <a target="_blank" :href="getSocialShareLink('facebook')" >
                    <i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" :href="getSocialShareLink('twitter')">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <!-- <li>
                  <a href="#">
                    <i class="fab fa-google-plus-g"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fas fa-rss"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fab fa-pinterest"></i>
                  </a>
                </li> -->
              </ul>
            </div>
            <div v-if="selectedProductLocal.stock && selectedProductLocal.lowest_price_stock">
              <button
                class="button button-outline-secondary"
                type="submit"
                @click.prevent="
                  _addToCart({
                    qty : quantity,
                    product_id: selectedProductLocal.id,
                    product_combination_id: combination_id,
                    price: selectedProductLocal.lowest_price,
                    warehouse_id : currWarehouse_id
                  })
                "
              >
               {{ selectedProductLocal.stock_status != 'OUT' ?  'Add to Cart' : 'Pre Order' }}
              </button>
              <button
                class="button button-outline-secondary far fa-heart u-s-m-l-6"
                @click.prevent="
                  addToWishlist({
                    product_id: selectedProductLocal.id,
                    product_combination_id: combination_id,
                    warehouse_id : currWarehouse_id
                  })
                "
              ></button>
              <button
                class="
                  button button-outline-secondary
                  far
                  fa-envelope
                  u-s-m-l-6
                "
              ></button>
            </div>
          </form>
        </div>
      </div>
      <!-- Product-details /- -->
    </div>
    	<RelatedProducts :products="selectedProductLocal.related_products" />
  </div>
  <vue-element-loading :active="status.cart.loading && !getStatus.products.loading" spinner="spinner" is-full-screen color="white" text="Adding Product" />
  <Product modal_id="product" :product_id="productId" :combination_id="combination_id" />
</template>

<script>
import { publicPath } from "../../../../../vue.config";
import { mapActions, mapGetters } from "vuex";
import {formatCurrency, msToHMS} from "../../../../utils/common_functions"
import StarRating from "vue-star-rating";
import Product from "../../../Modals/Product.vue"
import RelatedProducts from "./RelatedProducts.vue"
import _ from "lodash";
export default {
  components : {StarRating, Product,RelatedProducts},
  computed: {
    ...mapGetters("cart", ["getCarts", "status"]),
    ...mapGetters("products", ["selectedProduct", "getStatus"]),
    ...mapGetters("wishlist", ["getWishListItems"]),
    getRemainingTime() {
      return (this.initialTimer - this.deal_timer) / this.initialTimer * 100; //getting the remaining time in percentage
    },
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_URL,
      LIGHTENING_DEAL: process.env.VUE_APP_LIGHTENING_DEAL,
      publicPath: publicPath,
      productId: null,
      product_variants: [],
      combination: {},
      arrFromSearch: [],
      selectedProductLocal: [],
      combination_ids: [],
      combination_id: null,
      combPriceArr: [],
      stockArr:[],
      showVideo: false,
      removekeys: [
        "can",
        "user_id",
        "created_by",
        "updated_by",
        "deleted_at",
        "created_at",
        "updated_at",
        "api_route",
        "product_combination_id",
      ],
      warehouses : [],
      currWarehouse_id: null,
      quantity : 1,
      deal_timer: 3600000,
      initialTimer: 0,
    };
  },
  methods: {
    ...mapActions("cart", ["addToCart"]),
    ...mapActions("wishlist", ["addProductToWislist"]),
    formatCurrency,
    msToHMS,
    countDownTimer(){
      setTimeout(() => {
        if(this.deal_timer == 0) return;
        this.deal_timer -= 1000;
        this.countDownTimer();
      }, 1000)
    },
    changeThumbnail(image){
      if(image == 'video'){
        this.showVideo = true;
        return;
      }
      this.showVideo = false;
      this.selectedProductLocal.singleImage = image;
    },
    getSocialShareLink(type, data = null){
      // TEMP
      if(type == 'facebook'){
        return `https://www.facebook.com/sharer/sharer.php?u=${window.origin}/product/${this.selectedProduct.id}/${this.selectedProduct.product_slug}&quote=Checkout this amazing product.&hashtag=#${process.env.VUE_APP_SHOP_NAME}`
      }
      if(type == 'twitter'){
        return `https://twitter.com/intent/tweet?text=Check out this amazing product.&url=${window.origin}/product/${this.selectedProduct.id}/${this.selectedProduct.product_slug}&hashtags=${this.selectedProduct.category.category_slug}&via=${process.env.VUE_APP_SHOP_NAME}`
      }
    },
    getYoutubeThumbnail(url){
      let video_id = url.split('/').pop();
      return `https://img.youtube.com/vi/${video_id}/2.jpg`;
    },
    ProductExistInCart(id) {
      return this.getCarts.find((cart) => cart.product.id == id);
      // console.log(this.getProducts.some((product) => product.id == id))
    },
    createDropdown() {
      console.log("createdrop",this.selectedProduct.prices);
      let arrFromSearch = [];
      let arrToDisplay = [];
      this.selectedProduct.prices.forEach((price) => {
        let av = {},cp = {};
        //av -> attribute_variation cp-> combination_price
        price.attribute_variations.forEach((el) => {
          let obj = {};
          obj["combination_id"] = el.id;
          //obj["price"] = price.stock.total_price;
          //obj["sku"] = price.sku;
          obj["attribute_id"] = el.attribute_id;
          obj["attribute_name"] = el.attribute.name;
          // obj["attribute_id"] = 1;
          // obj["attribute_name"] = "size";

          obj["variation_id"] = el.variation_id;
          obj["variation_name"] = el.variation.name;
          obj["image"] = price.image;
          obj["stock"] = price.stock;
          obj["related_products"] = price.related_products;
          arrFromSearch.push(obj);
          av[el.attribute_id + ""] = el.variation_id;
        });
        price.stock.forEach((el) => {
          let st = {};
          st["comb_id"] = el.product_combination_id;
          st["warehouse_id"] = el.warehouse.id;
          st["total_price"] = el.total_price;
          st["qty"] = el.qty;
          st["stock_status"] = el.stock_status;
          st["installation_price"] = el.installation_price;
          st["mrp"] = el.mrp;
          st["promotional"] = el.promotional;
          this.stockArr.push(st);
        });
        cp["comb"] = av;
        cp["comb_id"] = price.id;
        //cp["price"] = price.stock.total_price;
        cp["sku"] = price.sku;
        cp["image"] = _.omit(price.image, this.removekeys);
        cp["stock"] = _.omit(price.stock, this.removekeys);
        cp["related_products"] = _.omit(price.related_products, this.removekeys);
        //cp["warehouse_id"] = price.stock.warehouse_id;
        this.combPriceArr.push(cp);
      });

      let result = {};
      let warehouses = [];
      arrFromSearch.forEach((el) => {
        el.stock.forEach(el => {
          const warehouse = warehouses.find(warehouse => warehouse.id === el.warehouse.id);
          if(!warehouse){
            warehouses.push(
            {
              id : el.warehouse.id, 
              name : el.warehouse.name,
              business_details : el.warehouse.businessdetails,
            }
          );
          }
          // warehouses[el.warehouse.id] = el.warehouse.name
        })
        if (result[el.attribute_name]) {
          let check = result[el.attribute_name].find(
            (ele) => ele.id == el.variation_id
          );
          if (!check) {
            result[el.attribute_name].push({
              id: el.variation_id,
              variation: el.variation_name,
              combination_id: el.combination_id,
            });
          }
        } else {
          result[el.attribute_name] = [];
          result[el.attribute_name].push({
            id: el.variation_id,
            variation: el.variation_name,
            combination_id: el.combination_id,
          });
        }
      });
      console.log("Warehoues", warehouses)
      this.warehouses = warehouses


      Object.keys(result).forEach((el) => {
        let obj = {};
        let attr_id = arrFromSearch.find(
          (element) => element.attribute_name == el
        ).attribute_id;
        obj["attribute_id"] = attr_id;
        obj["attribute"] = el;
        this.combination[attr_id] = "";
        this.combination_ids[el] = "";
        obj["variations"] = result[el];

        arrToDisplay.push(obj);
      });
      this.product_variants = arrToDisplay;

      //console.log("stockArr",this.stockArr);
    },
    onChangeWarehouse(data){
       this.currWarehouse_id = data.id;
       this.quantity = 1;
       this.updatePrices(data.id);
     },
    updatePrices(selectedWarehouse_id){
// console.log(selectedWarehouse);
// console.log(_this.stockArr);
       const _this = this;
       const combSelected = _.omitBy(_this.combination, (v) => v === "");
       _this.combPriceArr.every(function (item, i) {
         if (_.isEqual(combSelected, item["comb"])) {
           _this.selectedProductLocal.singleImage = item['image'];
            _this.selectedProductLocal.related_products = item['related_products'];
           _this.stockArr.every(function (stock, i) {
               if(selectedWarehouse_id && stock['comb_id'] == item['comb_id'] && stock['warehouse_id'] == selectedWarehouse_id){
                 console.log(stock)
                 _this.selectedProductLocal.lowest_price = stock['total_price'];
                  _this.selectedProductLocal.installation_price = stock['installation_price'];
                   _this.selectedProductLocal.mrp = stock['mrp'];
                   _this.selectedProductLocal.promotional = stock['promotional'];
                 _this.selectedProductLocal.stock = stock['qty'];
                  _this.selectedProductLocal['stock_status'] = stock['stock_status'];
                 _this.combination_id = stock['comb_id'];
                 _this.selectedProductLocal.warehouse_id = selectedWarehouse_id;
                 //return false;
               }else
                return true;
           });
         }else
          return true;
       });
     },
     onChange(event) {
       this.showVideo = false;
       this.updatePrices(this.currWarehouse_id);
       this.quantity = 1; //reset quantity
       console.log(this.selectedProductLocal)
     },
     handleQuantityChange(){ //update quantity
       if(this.quantity > this.selectedProductLocal.stock){ //check if quantity is greater than stock
         this.quantity = 1 //if quantity is greater than stock, reset to 1
       };
      },
     handleQuantity(type){ //increase or decrease quantity
       if(type == 'inc'){
          if(this.quantity < this.selectedProductLocal.stock){ //check if quantity is less than stock
            this.quantity++;
          }
       }
       if(type == 'dec'){
          if(this.quantity > 1){ //check if quantity is greater than 1
            this.quantity--;
          }
       }
     },
    // onChange(event) {
    //   console.log("combination");
    //   console.log(this.combination);
    //   console.log(this.combPriceArr[0]["comb"]);
    //   let state = this;
    //   const combSelected = _.omitBy(this.combination, (v) => v === "");
    //   this.combPriceArr.every(function (item, i) {
    //     if (_.isEqual(combSelected, item["comb"])) {
    //       console.log(_.get(item["image"], "path"));
    //       console.log(_.get(item["stock"], "qty"));
    //       console.log(item["comb_id"]);
    //       console.log(item["price"]);
    //       state.selectedProductLocal.lowest_price_sku = item["sku"];
    //       state.selectedProductLocal.lowest_price = item["price"];
    //       state.selectedProductLocal.stock = _.get(item["stock"], "qty");
    //       state.selectedProductLocal.singleImage = _.get(item["image"], "name");
    //       state.combination_id = item["comb_id"];
    //       state.selectedProductLocal.warehouse_id = item["warehouse_id"];
    //       return false;
    //     } else {
    //       console.log("NA"); // refresh to empty/no-selection or do nothing
    //       state.selectedProductLocal.stock = "";
    //       return true;
    //     }
    //   });



      // let data_name = event.target.options[event.target.options.selectedIndex].dataset.name;
      // let combinationId = event.target.options[event.target.options.selectedIndex].dataset.combinationId
      // this.combination_ids[data_name] = parseInt(combinationId)
      //  let array = Object.values(this.combination_ids);
      //  console.log(array)
      //  for (let index = 0; index < this.selectedProductLocal.prices.length; index++) {
      //    const element = this.selectedProductLocal.prices[index];
      //    if(Object.values(element.combination.attribute_variation_ids).sort().join(",") ==  array.sort().join(",")){
      //      console.log(element)
      //      this.selectedProductLocal.lowest_price = element.total_price
      //      break;
      //   }else{
      //     console.log("Not Exist")
      //     // break;
      //   }
      //  }
      // this.calculateProductDetails();
    // },

    changeProductDetails() {
      console.log(this.selectedProductLocal);
    },

    calculateProductDetails() {
      let attr_limit = Object.keys(this.combination).length;
    },

    _addToCart(data) {
      //if (this.getCarts.some((cart) => cart.product.id == data.product_id)) {
      //  this.$router.push({ name: "Cart" });
      //} else {
        this.addToCart(data);
      //}
    },

    addToWishlist(data) {
      // console.log(this.getWishListItems)
      if (
        this.getWishListItems.some(
          (wishlist) => wishlist.product.id == data.product_id
        )
      ) {
        this.$router.push({ name: "Wishlist" });
      } else {
        this.addProductToWislist(data);
      }
    },
    scroll(){
        const el = document.getElementsByClassName("page-style-a")[0];
          this.$smoothScroll({
            scrollTo: el, // scrollTo is also allowed to be number
            offset : 200
        });
    }
  },
  mounted() {
    console.log("Single Products Mounted.");
    this.scroll();
    this.productId = this.$route.params.id;
    this.createDropdown();
    this.selectedProductLocal = {
      ...this.selectedProduct,
      stock: this.selectedProduct.lowest_price_stock,
      stock_status: this.selectedProduct.lowest_price_relation.stock_status,
      installation_price : this.selectedProduct.lowest_price_relation.installation_price,
      mrp : this.selectedProduct.lowest_price_relation.mrp,
      singleImage: this.selectedProduct.lowest_price_image,
      promotional : this.selectedProduct.lowest_price_relation.promotional,
      related_products : this.selectedProduct.lowest_price_related_product,
    };
    this.combination_id = this.selectedProductLocal.lowest_price_relation.product_combination_id;
    this.currWarehouse_id = this.selectedProductLocal.lowest_price_relation.warehouse_id;
    const _this = this;
    _this.combPriceArr.every(function (item, i) {
      if(item['comb_id'] == _this.selectedProduct.lowest_price_relation.product_combination_id){
        const attr_var = JSON.parse(JSON.stringify(item['comb']));
       _this.combination = attr_var;
      }else
       return true;
    });

    //elevate zoom plugin
    $("#zoom-pro").elevateZoom({
      gallery: "gallery",
      galleryActiveClass: "active",
      borderSize: 1,
      zoomWindowWidth: 540,
      zoomWindowHeight: 540,
      zoomWindowOffetx: 10,
      borderColour: "#e9e9e9",
    });
    this.initialTimer = this.deal_timer
    this.countDownTimer();
  },
  beforeUnmount() {
    this.getStatus.selectedProduct.loading = true; // reset loading status before unmounting, to prevent calling API again
    console.log("Product Main Unmounted");
    $(".zoomContainer").remove();
  },
  watch: {
      '$route' (to, from) {
        this.scroll();
      }
    }
};
</script>

<style scoped>
.main_product_image{
  height: 400px;
}
.main_product_image img{
  height: 100%;
}
.gallery-thumb{
  cursor: pointer;
}
.gallery-thumb.active{
  border: 3px solid #343a40;
}
#video{
  position: relative;
  cursor: pointer;
}
.video_icon{
  position: absolute;
  left: -5px;
  right: 0;
}
.video_thumbnail{
  opacity: 0.4;
}
@media (max-width: 440px){
  .main_product_image{
   height: 300px;
  }
  .product-rating{
    justify-content: center;
  }
}
  

</style>
